import { render } from "./PlanGeneral.vue?vue&type=template&id=e2e589e4&ts=true"
import script from "./PlanGeneral.vue?vue&type=script&lang=ts"
export * from "./PlanGeneral.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__